import { injectable } from 'tsyringe';
import { OWSettings } from '../../odk-ts/ow-settings';

// -----------------------------------------------------------------------------
@injectable()
export class OWSettingsWrapper {
  public async getLanguage() {
    return OWSettings.getLanguage();
  }
}
